module.exports = __webpack_public_path__ + "img/LVA.9229d3b7.png";